import { Typography } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import React from 'react';

import styles from './DashboardResources.module.css';

export interface DashboardResourcesProps {
  title: string;
  description: string;
  href: string;
}

export const DashboardResources: React.FC<DashboardResourcesProps> = props => {
  const { title, description, href } = props;
  return (
    <a
      className={`${styles.resourceBox} xl:w-full xl:max-w-5xl p-5 flex flex-wrap justify-between items-center rounded-lg `}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="flex flex-col items-start">
        <Typography style={{ fontWeight: 'bold', fontSize: 20 }}>
          {title}
        </Typography>
        <Typography variant="body2">{description}</Typography>
      </div>
      <ChevronRightIcon style={{ color: '#fcd559' }} fontSize="large" />
    </a>
  );
};
